/* ==========================================================================
   Akel Beauty — fiche produit
   Variant selection, gallery, size guide, lace explanation, AJAX add-to-cart,
   sticky bar.
   ========================================================================== */

(function () {
  'use strict';

  function normalize(value) {
    return (value || '').toLowerCase().replace(/\s+/g, '');
  }

  function init() {
    var root = document.querySelector('[data-pdp]');
    if (!root) return;

    var dataNode = root.querySelector('[data-pdp-variants]');
    if (!dataNode) return;

    var variants;
    try {
      variants = JSON.parse(dataNode.textContent);
    } catch (e) {
      return;
    }
    if (!variants.length) return;

    var form = root.querySelector('[data-product-form]');
    var variantInput = root.querySelector('[data-variant-input]');
    var qtyInput = root.querySelector('[data-qty-input]');
    var errorNode = root.querySelector('[data-cart-error]');

    var urgencyThreshold = parseInt(root.getAttribute('data-urgency-threshold'), 10) || 0;
    var productTitle = (root.getAttribute('data-product-title') || '').trim();
    var hiddenOptionUnsafe = root.getAttribute('data-hidden-option-unsafe') === 'true';

    function showError(message) {
      if (!errorNode) return;
      errorNode.textContent = message;
      errorNode.hidden = !message;
    }

    var money = function (cents) {
      return window.Akel.formatMoney(cents, window.Akel.moneyFormat);
    };

    // Locale strings arrive as templates with __token__ placeholders, so
    // nothing user-facing is hardcoded in English here.
    function t(format, tokens) {
      var out = format || '';
      Object.keys(tokens || {}).forEach(function (key) {
        out = out.split('__' + key + '__').join(tokens[key]);
      });
      return out;
    }

    function variantLabel(variant) {
      if (!variant) return productTitle;
      var localized = (variant.localized_title || '').trim();
      if (localized) return localized;

      // Shopify's synthetic no-option variant is internal plumbing, not
      // customer-facing product information.
      var raw = (variant.title || '').trim();
      if (normalize(raw) === 'defaulttitle') return productTitle;
      return raw || productTitle;
    }

    /* ------------------------------------------------------------- State */

    var current =
      variants.filter(function (v) {
        return variantInput && String(v.id) === variantInput.value;
      })[0] || variants[0];

    var selected = current.options.slice();

    // Options omitted from the UI (for example an irrelevant legacy lace
    // service on a headband or U-part model) are constraints, not values the
    // fallback selector may silently change.
    var visibleOptionIndexes = {};
    root.querySelectorAll('.pdp-option[data-option-position]').forEach(function (group) {
      var visibleIndex = parseInt(group.getAttribute('data-option-position'), 10) - 1;
      if (!isNaN(visibleIndex) && visibleIndex >= 0) visibleOptionIndexes[visibleIndex] = true;
    });

    function preservesHiddenOptions(variant) {
      return selected.every(function (chosen, index) {
        return visibleOptionIndexes[index] || variant.options[index] === chosen;
      });
    }

    function findVariant(options) {
      return (
        variants.filter(function (v) {
          return options.every(function (value, index) {
            return v.options[index] === value;
          });
        })[0] || null
      );
    }

    /* --------------------------------------------------------- Availability */

    function refreshAvailability() {
      root.querySelectorAll('[data-option-value][data-option-position]').forEach(function (button) {
        var position = parseInt(button.getAttribute('data-option-position'), 10);
        var value = button.getAttribute('data-option-value');
        var index = position - 1;

        var inStock = variants.some(function (v) {
          if (v.options[index] !== value || !v.available) return false;
          return selected.every(function (chosen, i) {
            return i === index || v.options[i] === chosen;
          });
        });

        if (inStock) {
          button.removeAttribute('data-unavailable');
        } else {
          button.setAttribute('data-unavailable', 'true');
        }
      });
    }

    /* ------------------------------------------------------------ Gallery */

    var track = root.querySelector('[data-gallery-track]');
    var thumbs = root.querySelectorAll('[data-thumb]');

    function isCarousel() {
      return track && track.scrollWidth > track.clientWidth + 4;
    }

    function setActiveThumb(index) {
      thumbs.forEach(function (thumb) {
        thumb.setAttribute('aria-current', String(parseInt(thumb.getAttribute('data-thumb'), 10) === index));
      });
    }

    function goToIndex(index) {
      if (!track) return;
      var item = track.querySelector('[data-index="' + index + '"]');
      if (!item) return;
      setActiveThumb(index);
      if (isCarousel()) {
        track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      } else {
        item.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goToIndex(parseInt(thumb.getAttribute('data-thumb'), 10));
      });
    });

    if (track && thumbs.length) {
      setActiveThumb(0);
      var scrollTimer = null;
      track.addEventListener('scroll', function () {
        if (scrollTimer) window.cancelAnimationFrame(scrollTimer);
        scrollTimer = window.requestAnimationFrame(function () {
          if (!isCarousel()) return;
          var index = Math.round(track.scrollLeft / track.clientWidth);
          setActiveThumb(Math.max(0, Math.min(thumbs.length - 1, index)));
        });
      });
    }

    function showMedia(mediaId) {
      if (!track || !mediaId) return;
      var item = track.querySelector('[data-media-id="' + mediaId + '"]');
      if (!item) return;
      goToIndex(parseInt(item.getAttribute('data-index'), 10) || 0);
    }

    /* ----------------------------------------------------------- Quantity */

    function quantity() {
      var value = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      return isNaN(value) || value < 1 ? 1 : value;
    }

    function setQuantity(value) {
      if (!qtyInput) return;
      var max = parseInt(qtyInput.getAttribute('max'), 10) || 5;
      qtyInput.value = Math.max(1, Math.min(max, value));
      renderTotals();
    }

    var qtyDown = root.querySelector('[data-qty-down]');
    var qtyUp = root.querySelector('[data-qty-up]');
    if (qtyDown) {
      qtyDown.addEventListener('click', function () {
        setQuantity(quantity() - 1);
      });
    }
    if (qtyUp) {
      qtyUp.addEventListener('click', function () {
        setQuantity(quantity() + 1);
      });
    }
    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        setQuantity(quantity());
      });
    }

    /* ------------------------------------------------------------- Render */

    function setAll(selector, value) {
      root.querySelectorAll(selector).forEach(function (node) {
        node.textContent = value;
      });
    }

    function renderTotals() {
      if (!current) return;
      var total = current.price * quantity();
      setAll('[data-total]', money(total));
      var stickyTotal = root.querySelector('[data-sticky-total]');
      if (stickyTotal) stickyTotal.textContent = money(total);
    }

    function renderVariant() {
      if (!current) {
        root.querySelectorAll('[data-add-button]').forEach(function (button) {
          button.disabled = true;
        });
        setAll('[data-add-label]', window.Akel.strings.unavailable);
        return;
      }

      if (variantInput) variantInput.value = current.id;

      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', current.id);
        window.history.replaceState({}, '', url.toString());
      }

      setAll('[data-price]', money(current.price));

      setAll(
        '[data-add-label]',
        current.available ? window.Akel.strings.addToCart : window.Akel.strings.soldOut
      );

      var summary = root.querySelector('[data-sticky-summary]');
      if (summary) summary.textContent = variantLabel(current);

      // Low stock only where inventory is genuinely tracked and will run out.
      var urgency = root.querySelector('[data-urgency]');
      if (urgency) {
        var tracked = current.inventory_management === 'shopify';
        var willRunOut = current.inventory_policy !== 'continue';
        var qty = current.inventory_quantity;
        var show = tracked && willRunOut && qty > 0 && urgencyThreshold > 0 && qty <= urgencyThreshold;
        urgency.hidden = !show;
        if (show) {
          var count = urgency.querySelector('[data-urgency-count]');
          if (count) {
            count.textContent = t(window.Akel.strings.inventoryLowFormat, {
              count: qty,
              variant: variantLabel(current)
            });
          }
        }
      }

      showMedia(current.media_id);
      renderTotals();
      renderLaceExplanation();
      renderLaceProperties();
    }

    /* ------------------------------------------------------- Lace services */

    var laceServices = [];
    var servicesNode = root.querySelector('[data-lace-services]');
    if (servicesNode) {
      try {
        laceServices = JSON.parse(servicesNode.textContent);
      } catch (e) {
        laceServices = [];
      }
    }

    var ackBox = root.querySelector('[data-lace-ack]');
    var serviceInput = root.querySelector('[data-lace-service-input]');

    // "Ne pas couper la lace" contains "couper la lace", so a plain substring
    // test would match both blocks. The longest matching key wins.
    function matchService(key) {
      var chosen = selected.map(normalize);
      var best = null;
      var bestLength = 0;
      laceServices.forEach(function (service) {
        var candidate = normalize(service[key === 'match' ? 'match' : key]);
        if (!candidate) return;
        var hit = chosen.some(function (value) {
          return value.indexOf(candidate) !== -1;
        });
        if (hit && candidate.length > bestLength) {
          best = service;
          bestLength = candidate.length;
        }
      });
      return best;
    }

    function activeService() {
      return matchService('match');
    }

    function renderLaceExplanation() {
      var wrap = root.querySelector('[data-lace-explain]');
      if (!wrap) return;

      var active = activeService();
      var activeKey = active ? normalize(active.match) : '';

      wrap.querySelectorAll('[data-explain-for]').forEach(function (panel) {
        panel.hidden = normalize(panel.getAttribute('data-explain-for')) !== activeKey;
      });

      wrap.querySelectorAll('[data-detail-for]').forEach(function (panel) {
        panel.hidden = normalize(panel.getAttribute('data-detail-for')) !== activeKey;
      });
    }

    // Record which service is active and whether the final-sale notice was
    // displayed. This is deliberately not described as shopper acceptance:
    // the UI has no consent checkbox, and the visible notice does the actual
    // disclosure work.
    function renderLaceProperties() {
      var active = activeService();
      var isFinalSale = !!(active && active.final_sale);

      if (serviceInput) {
        serviceInput.value = active && active.property ? active.property : '';
      }

      // No tick-box is required. The hidden property accurately records that
      // the final-sale notice was displayed when the cut service was active.
      if (ackBox) {
        ackBox.value = isFinalSale ? ackBox.getAttribute('data-yes') || 'Oui' : '';
      }

      // The exchange guarantee is only true while the lace stays uncut.
      var card = root.querySelector('[data-guarantee-card]');
      if (card) card.hidden = isFinalSale;

      updateAddButtons();
    }

    function updateAddButtons() {
      var blocked = hiddenOptionUnsafe || !current || !current.available;
      root.querySelectorAll('[data-add-button]').forEach(function (button) {
        button.disabled = blocked;
      });
    }

    if (ackBox) {
      ackBox.addEventListener('change', function () {
        updateAddButtons();
        if (ackBox.checked) showError('');
      });
    }

    /* ------------------------------------------------------ Option picking */

    root.querySelectorAll('[data-option-value][data-option-position]').forEach(function (button) {
      button.addEventListener('click', function () {
        var position = parseInt(button.getAttribute('data-option-position'), 10);
        var value = button.getAttribute('data-option-value');
        var index = position - 1;
        if (isNaN(index) || index < 0) return;

        selected[index] = value;

        var match = findVariant(selected);
        // The clicked value exists but not with the rest of the selection:
        // honour the click and relax the other options to the nearest variant.
        if (!match) {
          var fallback = variants.filter(function (v) {
            return v.options[index] === value && v.available && preservesHiddenOptions(v);
          })[0];
          if (!fallback) {
            fallback = variants.filter(function (v) {
              return v.options[index] === value && preservesHiddenOptions(v);
            })[0];
          }
          if (fallback) {
            selected = fallback.options.slice();
            match = fallback;
          }
        }

        current = match;
        syncOptionUI();
        refreshAvailability();
        renderVariant();
      });
    });

    function syncOptionUI() {
      root.querySelectorAll('.pdp-option').forEach(function (group) {
        var position = parseInt(group.getAttribute('data-option-position'), 10);
        var value = selected[position - 1];

        group.querySelectorAll('[data-option-value]').forEach(function (button) {
          button.setAttribute('aria-checked', String(button.getAttribute('data-option-value') === value));
        });
      });
    }

    /* --------------------------------------------------- Guide disclosures */

    root.querySelectorAll('[data-guide-toggle]').forEach(function (toggle) {
      var panel = root.querySelector('#' + toggle.getAttribute('data-guide-toggle'));
      if (!panel) return;
      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isOpen));
        panel.hidden = isOpen;
        if (!isOpen) panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
    });

    var laceDetailToggle = root.querySelector('[data-lace-detail-toggle]');
    if (laceDetailToggle) {
      var laceDetailDialog = root.querySelector('#' + laceDetailToggle.getAttribute('data-lace-detail-toggle'));
      if (laceDetailDialog) {
        var laceDetailClose = laceDetailDialog.querySelector('[data-lace-detail-close]');

        function openLaceDetail() {
          laceDetailToggle.setAttribute('aria-expanded', 'true');
          document.documentElement.classList.add('drawer-open');

          if (typeof laceDetailDialog.showModal === 'function') {
            laceDetailDialog.showModal();
          } else {
            laceDetailDialog.setAttribute('open', '');
          }

          if (laceDetailClose) laceDetailClose.focus();
        }

        function closeLaceDetail() {
          if (typeof laceDetailDialog.close === 'function' && laceDetailDialog.open) {
            laceDetailDialog.close();
          } else {
            laceDetailDialog.removeAttribute('open');
            laceDetailToggle.setAttribute('aria-expanded', 'false');
            document.documentElement.classList.remove('drawer-open');
            laceDetailToggle.focus();
          }
        }

        laceDetailToggle.addEventListener('click', openLaceDetail);

        if (laceDetailClose) {
          laceDetailClose.addEventListener('click', closeLaceDetail);
        }

        // Clicking the dimmed backdrop closes the modal; clicks inside the
        // white surface do not bubble to this branch.
        laceDetailDialog.addEventListener('click', function (event) {
          if (event.target === laceDetailDialog) closeLaceDetail();
        });

        laceDetailDialog.addEventListener('keydown', function (event) {
          if (event.key !== 'Escape') return;
          event.preventDefault();
          closeLaceDetail();
        });

        laceDetailDialog.addEventListener('close', function () {
          laceDetailToggle.setAttribute('aria-expanded', 'false');
          document.documentElement.classList.remove('drawer-open');
          laceDetailToggle.focus();
        });
      }
    }

    /* --------------------------------------------------------- Sticky bar */

    var stickyBar = root.querySelector('[data-sticky-bar]');
    var anchor = root.querySelector('[data-atc-anchor]');

    // Deliberately a scroll listener rather than an IntersectionObserver.
    // IO only reports threshold *crossings*, so a missed or coalesced callback
    // leaves the bar stuck in the wrong state for the rest of the session —
    // and this is the buy button, not decoration. Reading the anchor position
    // each frame is self-correcting: whatever happened before, the next frame
    // is right.
    if (stickyBar && anchor) {
      var stickyQueued = false;

      var syncSticky = function () {
        stickyQueued = false;
        var scrolledPast = anchor.getBoundingClientRect().bottom < 0;
        if (stickyBar.hidden === scrolledPast) {
          stickyBar.hidden = !scrolledPast;
          // Reserve space so the bar never covers the end of the page.
          document.documentElement.classList.toggle('has-sticky-atc', scrolledPast);
        }
      };

      var queueSticky = function () {
        if (stickyQueued) return;
        stickyQueued = true;
        window.requestAnimationFrame(syncSticky);
      };

      window.addEventListener('scroll', queueSticky, { passive: true });
      window.addEventListener('resize', queueSticky, { passive: true });
      syncSticky();
    }

    /* --------------------------------------------------------- Add to cart */

    // Line-item properties are read straight off the form, so the JS and
    // no-JS paths send exactly the same thing. An unticked checkbox is simply
    // absent, and Shopify drops properties with an empty value.
    function collectProperties() {
      if (!form) return {};
      var properties = {};
      form.querySelectorAll('[name^="properties["]').forEach(function (field) {
        if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
        if (!field.value) return;
        var name = field.getAttribute('name').replace(/^properties\[/, '').replace(/\]$/, '');
        properties[name] = field.value;
      });
      return properties;
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (hiddenOptionUnsafe || !current || !current.available) return;

        showError('');

        var buttons = root.querySelectorAll('[data-add-button]');
        buttons.forEach(function (button) {
          button.disabled = true;
        });

        var item = { id: current.id, quantity: quantity() };
        var properties = collectProperties();
        if (Object.keys(properties).length) item.properties = properties;

        fetch(window.Akel.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        })
          .then(function (response) {
            return response.json().then(function (body) {
              if (!response.ok) {
                throw new Error(body.description || body.message || window.Akel.strings.cartError);
              }
              return body;
            });
          })
          .then(function () {
            return fetch(window.Akel.routes.cart_url + '.js', {
              headers: { Accept: 'application/json' }
            }).then(function (response) {
              return response.json();
            });
          })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('akel:cart:updated', { detail: cart }));
            setAll('[data-add-label]', window.Akel.strings.added);
            setTimeout(function () {
              setAll('[data-add-label]', window.Akel.strings.addToCart);
            }, 2400);
          })
          .catch(function (error) {
            showError(error.message);
          })
          .finally(updateAddButtons);
      });
    }

    /* --------------------------------------------------------------- Boot */

    syncOptionUI();
    refreshAvailability();
    renderVariant();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Gallery arrows: nudge the snap track by one item. Added late, so it binds
   itself rather than being folded into the gallery initialiser above. */
(function () {
  'use strict';
  function init() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var track = gallery.querySelector('[data-gallery-track]');
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (!track || !prev || !next) return;

    function step() {
      var item = track.firstElementChild;
      return item ? item.getBoundingClientRect().width + 10 : track.clientWidth;
    }
    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
